export const REWARDS_SPENDING_RULES_TYPES = {
    percentageDiscount: "PERCENTAGE_DISCOUNT",
    amountDiscount: "AMOUNT_DISCOUNT",
    freeProduct: "FREE_PRODUCT",
    freeShipping: "FREE_SHIPPING",
    giftCard: "GIFT_CARD",
} as const;

export const REWARDS_SPENDING_RULES_REDEEM_REWARD_TYPES = {
    percentageDiscount: "PERCENTAGE_DISCOUNT",
    amountDiscount: "AMOUNT_DISCOUNT",
    productDiscount: "PRODUCT_DISCOUNT",
    shippingDiscount: "SHIPPING_DISCOUNT",
    giftCard: "GIFT_CARD",
} as const;

export const REWARDS_SPENDING_RULES_REWARD_TYPES = {
    fixedPoints: "FIXED_POINTS",
    flexiblePoints: "FLEXIBLE_POINTS",
    fixedPercentageDiscount: "FIXED_PERCENTAGE_DISCOUNT",
    flexiblePercentageDiscount: "FLEXIBLE_PERCENTAGE_DISCOUNT",
    fixedAmountDiscount: "FIXED_AMOUNT_DISCOUNT",
    flexibleAmountDiscount: "FLEXIBLE_AMOUNT_DISCOUNT",
    productDiscount: "PRODUCT_DISCOUNT",
    shippingDiscount: "SHIPPING_DISCOUNT",
    giftCard: "GIFT_CARD",
} as const;

export const REWARDS_LOYALTY_INFO_SPENDING_RULES_TYPES = {
    expensive: "EXPENSIVE",
    notEnoughPoints: "NOT_ENOUGH_POINTS",
} as const;
